import EntityBaseRepository from '@/api/EntityBaseRepository';
import { AxiosResponse } from 'axios';

export default class MaintenanceListElementEntryRepository extends EntityBaseRepository {

    // public getAllItems(): Promise<AxiosResponse> {
    //     return this.axiosClient.get('/maintenanceListElementEntry');
    // }

    public createItem(item: any): Promise<AxiosResponse> {
        return this.axiosClient.post('/maintenanceListElementEntry', item);
    }

    public deleteItem(id: string): Promise<AxiosResponse> {
        return this.axiosClient.delete(`/maintenanceListElementEntry/${id}`);
    }

    public updateItem(id: string, item: any): Promise<AxiosResponse> {
        return this.axiosClient.patch(`/maintenanceListElementEntry/${id}`, item);
    }

    public getCountByMaintenanceListElement(maintenanceListElementId: string): Promise<AxiosResponse> {
        console.log('maintenanceListElementId', maintenanceListElementId);
        return this.axiosClient.get(`/maintenanceListElementEntry/count/${maintenanceListElementId}`);
    }

    // public getItem(id: number): Promise<AxiosResponse> {
    //     return this.axiosClient.get(`/maintenanceListElementEntry/${id}`);
    // }

    // public getItemsByActuatorType(actuatorTypeId: string): Promise<AxiosResponse> {
    //     return this.axiosClient.get(`/maintenanceListElementEntry/actuatorType/${actuatorTypeId}`);
    // }
    
}
